import Editor from './code-editor';

import 'brace/ext/language_tools';
import 'brace/theme/chaos';
import 'brace/theme/gob';
import 'brace/theme/tomorrow';
import 'brace/mode/javascript';
import 'brace/mode/sql';
import 'brace/mode/json';
import 'brace/mode/markdown';

export default Editor;
